<h2 mat-dialog-title>{{ 'MESSAGE_SET_BUILDER.PREVIEW_TITLE' | translate }}</h2>

<mat-dialog-content>
  <cm-message-set-preview [messageSet]="messageSet"></cm-message-set-preview>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
</mat-dialog-actions>
